import React from "react";

import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';
import {
  cst_request_parking_status,
  cst_estimate_status,
  cst_request_type
} from '../../variables/codes_map';

export default class StatusChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            data: this.props.data?this.props.data:[],
            column: this.default_column,
            selected: null,
        };
        
        this.clickSelectButton = this.clickSelectButton.bind(this);
        
    }
    componentDidUpdate(prevProps) {
      if (JSON.stringify(this.props.data) === JSON.stringify(prevProps.data))
          return;
  
      let state = Object.create(this.state);
      // state.default_column = this.props.column ? this.props.column : [];
      // state.targetted_default_column = this.props.column ? this.props.column.filter((item) => { return !item.nonTargetFilter; }) : [];
      // state.column = state.default_column;
      // state.data = this.props.data ? this.props.data : [];
  
      this.setState({
        ...this.state,
        data:this.props.data
      });
    }  


    // 初期ロード用
    UNSAFE_componentWillMount() {
        /*　ここは開発者が記述　*/

        // TODO 本番では有効にする
        // this.search("");
        //this.search("1");
    }

  clickSelectButton(node) {
    if (this.props.nodeSelectedCallback) {
      this.props.nodeSelectedCallback(node);
    }
    return
  }
  
  getStatusByNodeType(node){
    if(node.hasOwnProperty('request_parking_status')){
      const matchedStatus = cst_request_parking_status.find(element=>(element.value==node.request_parking_status))
      return matchedStatus&&matchedStatus.label
    }else if(node.hasOwnProperty('order_status')){
      const matchedStatus = cst_estimate_status.find(element=>(element.value==node.order_status))
      return matchedStatus&&matchedStatus.label
    }else if(node.hasOwnProperty('request_type')){
      const matchedStatus = cst_request_type.find(element=>(element.value==node.request_type))
      return matchedStatus&&matchedStatus.label
    }
    
  }
    render() {
      
      return (
        <>
        <OrgChart tree={this.state.data} NodeComponent={({node}) => {
          const name = node.name||this.getStatusByNodeType(node)
          if (name){
            return (
              <div className={"initechNode " + (node.active?"node_active":"")}
                onClick={() => {this.clickSelectButton(node)}}
                style={node.border&&{border:node.border}}
              >
                { name }
              </div>
            )
          } else {
            return ''
          }
        }}/>
        </>
      );
    }
}
